
import "/app/src/components/TableCellText.module.less?modules";
export default {"cell": `cell-2BtVWw28`,"text": `text-NNCbulZk`,"copy": `copy-ZZagrIPG`}
